import { FunctionComponent } from 'react';

import styles from './Term.module.scss';

export type TermProps = {
  term: string | React.JSX.Element;
  center?: boolean;
};

type FC = FunctionComponent<TermProps>;

const Term: FC = ({ term, center = false }: TermProps) => (
  <div style={{ textAlign: center ? 'center' : undefined }} className={styles.term}>
    {term}
  </div>
);

export default Term;
